var _path, _path2, _circle, _path3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 52,
    viewBox: "0 0 38 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.26 43.4717H5.98576C5.48863 43.469 4.99747 43.369 4.54328 43.1778C4.08909 42.9866 3.68174 42.7084 3.34694 42.3607C2.63169 41.6331 2.23776 40.6742 2.2459 39.6807L2 8.56116L5.83896 5.39506L11.1753 1H30.26C30.7571 1.00261 31.2483 1.10268 31.7025 1.29389C32.1567 1.4851 32.564 1.76329 32.8988 2.11091C33.6141 2.83857 34.008 3.79744 33.9999 4.791V39.6807C34.008 40.6742 33.6141 41.6331 32.8988 42.3607C32.564 42.7084 32.1567 42.9866 31.7025 43.1778C31.2483 43.369 30.7571 43.469 30.26 43.4717ZM11.1753 1.4652L2 8.56116L11.4763 8.76599L11.1937 1.47561L11.1753 1.4652Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.56116L2.2459 39.6807C2.23776 40.6742 2.63169 41.6331 3.34694 42.3607C3.68174 42.7084 4.08909 42.9866 4.54328 43.1778C4.99747 43.369 5.48863 43.469 5.98576 43.4717H30.26C30.7571 43.469 31.2483 43.369 31.7025 43.1778C32.1567 42.9866 32.564 42.7084 32.8988 42.3607C33.6141 41.6331 34.008 40.6742 33.9999 39.6807V4.791C34.008 3.79744 33.6141 2.83857 32.8988 2.11091C32.564 1.76329 32.1567 1.4851 31.7025 1.29389C31.2483 1.10268 30.7571 1.00261 30.26 1H11.1753L5.83896 5.39506L2 8.56116ZM2 8.56116L11.1753 1.4652L11.1937 1.47561L11.4763 8.76599L2 8.56116Z",
    stroke: "#747272",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 41,
    r: 11,
    fill: "#FBB500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0713 43.9014V45H21.0576V43.9014H25.0713ZM24.9932 40.5273L21.624 45H20.6816V44.165L24.0361 39.7168H24.9932V40.5273ZM24.4951 39.7168V40.8203H20.7598V39.7168H24.4951ZM27.4395 39.7168V45H26.0283V39.7168H27.4395ZM25.9404 38.3398C25.9404 38.1348 26.012 37.9655 26.1553 37.832C26.2985 37.6986 26.4906 37.6318 26.7314 37.6318C26.9691 37.6318 27.1595 37.6986 27.3027 37.832C27.4492 37.9655 27.5225 38.1348 27.5225 38.3398C27.5225 38.5449 27.4492 38.7142 27.3027 38.8477C27.1595 38.9811 26.9691 39.0479 26.7314 39.0479C26.4906 39.0479 26.2985 38.9811 26.1553 38.8477C26.012 38.7142 25.9404 38.5449 25.9404 38.3398ZM30.0078 40.7324V47.0312H28.6016V39.7168H29.9053L30.0078 40.7324ZM33.3525 42.2998V42.4023C33.3525 42.7865 33.307 43.1429 33.2158 43.4717C33.1279 43.8005 32.9977 44.0869 32.8252 44.3311C32.6527 44.5719 32.4378 44.7607 32.1807 44.8975C31.9268 45.0309 31.6338 45.0977 31.3018 45.0977C30.9795 45.0977 30.6995 45.0326 30.4619 44.9023C30.2243 44.7721 30.0241 44.5898 29.8613 44.3555C29.7018 44.1178 29.5732 43.8428 29.4756 43.5303C29.3779 43.2178 29.3031 42.8825 29.251 42.5244V42.2559C29.3031 41.8717 29.3779 41.5202 29.4756 41.2012C29.5732 40.8789 29.7018 40.6006 29.8613 40.3662C30.0241 40.1286 30.2227 39.9447 30.457 39.8145C30.6947 39.6842 30.973 39.6191 31.292 39.6191C31.6273 39.6191 31.9219 39.6826 32.1758 39.8096C32.4329 39.9365 32.6478 40.1188 32.8203 40.3564C32.9961 40.5941 33.1279 40.8773 33.2158 41.2061C33.307 41.5348 33.3525 41.8994 33.3525 42.2998ZM31.9414 42.4023V42.2998C31.9414 42.0752 31.9219 41.8685 31.8828 41.6797C31.847 41.4876 31.7884 41.32 31.707 41.1768C31.6289 41.0335 31.5247 40.9229 31.3945 40.8447C31.2676 40.7633 31.113 40.7227 30.9307 40.7227C30.7386 40.7227 30.5742 40.7536 30.4375 40.8154C30.304 40.8773 30.195 40.9668 30.1104 41.084C30.0257 41.2012 29.9622 41.3411 29.9199 41.5039C29.8776 41.6667 29.8516 41.8506 29.8418 42.0557V42.7344C29.8581 42.9753 29.9036 43.1917 29.9785 43.3838C30.0534 43.5726 30.1689 43.7223 30.3252 43.833C30.4814 43.9437 30.6865 43.999 30.9404 43.999C31.126 43.999 31.2822 43.9583 31.4092 43.877C31.5361 43.7923 31.6387 43.6768 31.7168 43.5303C31.7982 43.3838 31.8551 43.2145 31.8877 43.0225C31.9235 42.8304 31.9414 42.6237 31.9414 42.4023Z",
    fill: "#303030"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 2,
    x2: 22.5,
    y2: 5,
    stroke: "#747272",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 4,
    x2: 25.5,
    y2: 7,
    stroke: "#747272",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 6,
    x2: 22.5,
    y2: 9,
    stroke: "#747272",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 8,
    x2: 25.5,
    y2: 11,
    stroke: "#747272",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 10,
    x2: 22.5,
    y2: 13,
    stroke: "#747272",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 12,
    x2: 25.5,
    y2: 15,
    stroke: "#747272",
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 14,
    x2: 22.5,
    y2: 17,
    stroke: "#747272",
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 16,
    x2: 25.5,
    y2: 19,
    stroke: "#747272",
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 18,
    x2: 22.5,
    y2: 21,
    stroke: "#747272",
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 20,
    x2: 25.5,
    y2: 23,
    stroke: "#747272",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 24C21.25 23.0335 22.0335 22.25 23 22.25H24C24.9665 22.25 25.75 23.0335 25.75 24V29C25.75 29.9665 24.9665 30.75 24 30.75H23C22.0335 30.75 21.25 29.9665 21.25 29V24Z",
    fill: "#747272",
    stroke: "#303030",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 23.5H24.5V25.5H22.5V23.5Z",
    fill: "#303030"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.91176affb14a93b21388f2fb3d78be84.svg";
export { ForwardRef as ReactComponent };